import template from './vault_operations.html';
import controller from './vault_operations.controller';
import './vault_operations.scss';

let vaultOperationsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default vaultOperationsComponent;


// WEBPACK FOOTER //
// ./client/app/components/vault_operations/vault_operations.component.js